import React, { useEffect } from "react"
import { AdminLoginForm } from "../../components/AdminLoginForm"
import { useIsAuthenticated } from "react-auth-kit"
import { useLocation, useNavigate } from "react-router-dom"

export const AdminLoginPage = () => {
  const isAuthenticated = useIsAuthenticated()
  const navigate = useNavigate()
  const location = useLocation()
  const notification = location.state?.notification

  useEffect(() => {
    if (notification) {
      // Clear the notification from the location state after it has been displayed
      navigate(location.pathname, {
        state: { ...location.state, notification: null },
        replace: true,
      })
    }
  }, [notification, location, navigate])

  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/admin/dashboard", {
        state: { notification: "You are already logged in!" },
      })
    }
  }, [isAuthenticated, navigate])

  return <AdminLoginForm notification={notification} />
}
